import React, { useState, createRef, useEffect } from 'react'


import {
    Box,
    Button
} from '@mui/material';

import { useNavigate, Link } from 'react-router-dom';

// import DateFilter from '@inovua/reactdatagrid-community/DateFilter'
import { icons } from '../../../../../components/common/CommonIcons';
import CommonBreadcumbs from '../../../../../components/common/CommonBreadcumbs';
import DataGridToolbar from '../../../../../components/common/DataGridToolbar';
import DataGridTable from '../../../../../components/common/DataGridTable';
import DataGridRowActionMenu from '../../../../../components/common/DataGridRowActionMenu';
import CommonRestricted from '../../../../../components/common/CommonRestricted';

import { useSystemPrompt } from '../../../../../hooks/useSystemPrompt';
import { useDataGridParams } from '../../../../../hooks/useDataGridParams';
import { useSystemRoutes, routeTypes } from '../../../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../../../hooks/usePermissions';
import { useTranslations } from "../../../../../hooks/useTranslations";

import { useCustomer, customerInjectionProps } from '../../../hooks/model/useCustomer';

import { getInjectionDataType } from '../../../utils/injectionSelection';

export default function ListCustomers({
    routeType
}) {

    const { t } = useTranslations({ ns: ["common", "_common"] })

    const navigate = useNavigate();
    const { promptMessage } = useSystemPrompt();

    const { listCustomers } = useCustomer({ routeType })

    const { defineColumns, columns, filterValues, getRenderColumnLink, getRenderColumnBooleanDisplay, getRenderColumnTextDisplay } = useDataGridParams('id')
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.user.id, scopeTypes.user.customer.id)

    const [selectedIds, setSelectedIds] = useState([])
    const [refreshDataGrid, setRefreshDataGrid] = useState(0)
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const gridRef = createRef();

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
    }

    const fetchData = async (props) => {

        resetDataGridTableSelection();

        try {

            const { data, count } = await listCustomers({
                props,
                dataTypes: [`${getInjectionDataType('customer')}`, "branch_count", "branch_user_count"]
            })

            return {
                data,
                count
            }

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)

            return {
                data: [],
                count: 0
            }
        }
    }

    // const filterValue =
    //     [
    //         // { name: 'action', operator: 'eq', type: 'string', value: '' },
    //         { name: 'account_code', operator: 'eq', type: 'string', value: '' },
    //         { name: 'username', operator: 'eq', type: 'string', value: '' },
    //         { name: 'firstname', operator: 'eq', type: 'string', value: '' },
    //         { name: 'lastname', operator: 'eq', type: 'string', value: '' },
    //         { name: 'contact', operator: 'eq', type: 'string', value: '' },
    //         { name: 'email', operator: 'eq', type: 'string', value: '' },
    //         { name: 'company_name', operator: 'eq', type: 'string', value: '' },
    //         //   { name: 'ax_createdatetime', operator: 'eq', type: 'string', value: '' },
    //     ];

    useEffect(() => {

        defineColumnsView()

    }, [])

    const defineColumnsView = () => {
        defineColumns([
            {
                name: 'username',
                header: t('username'),
                renderValue: ({ value, cellProps }) => {

                    // if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) === false) {
                    //     return getRenderColumnTextDisplay(value)
                    // }

                    let path = getRoute(`users/customer/update/${cellProps.data.user_id}`);

                    return getRenderColumnLink(path, value)

                }
            },
            {
                name: 'company_name', header: t('company')
            },
            {
                name: 'firstname', header: t('firstName')
            },
            {
                name: 'lastname', header: t('lastName')
            },
            {
                name: customerInjectionProps.sourceProfileType.retrieveKey,
                header: t('type'),
                // renderValue: ({ cellProps, value }) => getRenderColumnBooleanDisplay(value, ["Enabled", "Disabled"], ["primary", "default"], "")
            },

            // {
            //     name: 'contact', header: 'Contact'
            // },
            // { 
            //     name: 'email', header: 'Email' 
            // },
            {
                name: 'status',
                header: t('status'),
                renderValue: ({ cellProps, value }) => getRenderColumnBooleanDisplay(value, ["Enabled", "Disabled"], ["primary", "default"], "")
            },
            {
                name: 'branch_count',
                header: t('marking'),
                renderValue: ({ value, cellProps }) => {

                    let displayValue = parseInt(value, 10) > 0 ? `${value} ${t('markings')}` : ``

                    return (
                        <>{displayValue}</>
                    )

                }
            },

            {
                name: customerInjectionProps.sourceClientRemId.retrieveKey,
                header: 'SourceClient',
                // renderValue: ({ cellProps, value }) => getRenderColumnBooleanDisplay(value, ["Enabled", "Disabled"], ["primary", "default"], "")
            },

            {
                name: customerInjectionProps.sourceAgentRemId.retrieveKey,
                header: 'SourceAgent',
                // renderValue: ({ cellProps, value }) => getRenderColumnBooleanDisplay(value, ["Enabled", "Disabled"], ["primary", "default"], "")
            },
            // {
            //     name: 'branch_user_count',
            //     header: 'Users',
            //     renderValue: ({ value, cellProps }) => {

            //         let displayValue = parseInt(value, 10) > 0 ? `${value} User` : ``

            //         return (
            //             <>{displayValue}</>
            //         )

            //     }
            // }
        ])
    }

    // const handleDelete = async () => {

    //     try {

    //         let result = await remove({ ids: selectedIds, targetType: targetTypes.customer })

    //         promptMessage(true, result?.message)
    //         setRefreshDataGrid(val => val + 1)

    //     } catch (error) {
    //         promptMessage(false, error?.message)
    //     }

    // }

    const RenderToolbar = () => {

        const getToolbarMainMenus = () => {

            let props = [];

            // if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
            //     props.push({
            //         displayIconName: icons.plus,
            //         displayText: t("newCustomer"),
            //         onClick: () => {
            //             navigate(getRoute("users/customer/new"));
            //         }
            //     })
            // }

            props.push({
                displayIconName: icons.burger,
                displayText: t('markingList'),
                onClick: () => {

                    navigate(getRoute("users/customers/markings"));

                }
            })

            return props
        }

        const getActionOnClick = () => {

            let handleFunction = null

            // if (isPermissionAllow({ functionType: functionTypes.remove.id })) {
            //     handleFunction = handleDelete
            // }

            return handleFunction
        }

        return (
            <DataGridToolbar
                selectedRowCount={
                    selectedIds.length
                }
                mainMenus={
                    getToolbarMainMenus()
                }
                actionOnClickRemove={
                    getActionOnClick()
                }
                actionMenus={[]}
            />
        )
    }

    const RenderDataGridTable = () => {

        return (
            <DataGridTable
                ref={gridRef}
                refresh={refreshDataGrid}
                fetchData={fetchData}
                dataGrid={{
                    idProperty: "user_id",
                    style: {
                        minHeight: 600
                    },
                    pageSizes: [20, 50, 100],
                    defaultLimit: 10,
                    defaultSkip: 0,
                    // checkboxColumn:
                    //     isPermissionAllow({ functionType: functionTypes.remove.id }),
                    checkboxColumn: false,
                    columns,
                    defaultFilterValue: filterValues,
                    onSelectionChange: (items) => {
                        setSelectedIds(
                            items
                        )
                    }
                }}

            />
        )
    }

    return (
        <Box>

            {
                getHtmlHead({ routeType, title: headTitles.customers })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t('customers')}
                breadcrumbs={[
                    {
                        displayText: `${t('customers')} (*)`,
                        props: {
                            // underline: "hover",
                            // href: "/"
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    <>
                        {
                            RenderToolbar()
                        }
                        {
                            RenderDataGridTable()
                        }
                    </>
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}
